"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon20Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon20Regular = forwardRef_1.forwardRef('SearchLoupeIcon20Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.502a7.498 7.498 0 1 0 4.745 13.303l3.526 3.526a.75.75 0 0 0 1.06-1.06l-3.525-3.526A7.498 7.498 0 0 0 9 1.503ZM3.002 9a5.998 5.998 0 1 1 11.996 0A5.998 5.998 0 0 1 3.002 9Z" })));
});
